import {
  Component,
  OnInit,
  ViewChild
} from "@angular/core";
import {UntypedFormGroup, UntypedFormControl, Validators} from "@angular/forms";
import {DateValidation} from "../../validators/dateValidation";
import {localeSwedish} from "../locale.swedish";
import {ToastrService} from "ngx-toastr";
import {
  SPINNER_ANIMATIONS,
  SPINNER_PLACEMENT,
  ISpinnerConfig,
  NgxSpinner,
} from "@hardpool/ngx-spinner";
import {ReportService} from "../../services/report.service";
import {CheckInData} from "../../model/report/checkInReport";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";


@Component({
  selector: "checkIn-report",
  templateUrl: "checkIn-report.component.html",
  styleUrls: ["checkIn-report.component.css"],
})
export class CheckInReportComponent implements OnInit {
  @ViewChild("spinner", {static: true}) spinner: NgxSpinner;

  public displayedColumns = ['name', 'checkInAsLocalDateString', 'checkOutAsLocalDateString'];

  searchForm: UntypedFormGroup;
  busy: boolean = false;
  noMatch: boolean = false;

  maxDate: Date = new Date();
  checkInData: CheckInData[];
  public dataSource: MatTableDataSource<CheckInData>;
  @ViewChild(MatSort) sort: MatSort;

  spinnerConfig: ISpinnerConfig;
  localeText = {};

  constructor(
    private readonly toaster: ToastrService,
    private readonly reportService: ReportService) {
    this.localeText = localeSwedish;

    this.searchForm = new UntypedFormGroup({
      startDate: new UntypedFormControl([Validators.required, DateValidation()]),
      startTime: new UntypedFormControl([Validators.required]),
      endDate: new UntypedFormControl([Validators.required, DateValidation()]),
      endTime: new UntypedFormControl([Validators.required]),
      flight: new UntypedFormControl(""),
    });
  }


  ngOnInit() {
    this.spinnerConfig = {
      placement: SPINNER_PLACEMENT.block_ui,
      animation: SPINNER_ANIMATIONS.horizontal_bounce,
      size: "2rem",
      color: "#7AB800",
      bgColor: "transparent",
    };

    this.startTimeInput.setValue("00:00");
    this.endTimeInput.setValue("23:59");
    this.startDateInput.setValue(new Date());
    this.endDateInput.setValue(new Date());

    this.startDateInput.valueChanges.subscribe(() => {
      this.inputChange();
    });

    this.endDateInput.valueChanges.subscribe(() => {
      this.inputChange();
    });

  }

  canSearch() {
    return this.searchForm.valid && !this.busy;
  }

  inputChange() {
    this.checkInData = null;
    this.dataSource = null;
  }

  async search() {
    if (this.searchForm.valid) {
      this.spinner.show();

      if (!this.startTimeInput.touched) {
        this.startTimeInput.setValue("00:00");
      }
      if (!this.endTimeInput.touched) {
        this.endTimeInput.setValue("23:59");
      }

      let startDateTime = this.addHoursAndMinutesFromTimePickerString(this.startDateInput.value, this.startTimeInput.value);
      let endDateTime = this.addHoursAndMinutesFromTimePickerString(this.endDateInput.value, this.endTimeInput.value);

      this.busy = true;
      this.noMatch = false;
      this.checkInData = [];
      try {
        let response: any = await this.reportService.getCheckInReport(
          startDateTime,
          endDateTime
        );
        this.spinner.hide();

        response.forEach((report) => {
          let checkInData = CheckInData.ToTypeSafe(report);
          this.checkInData.push(checkInData);
        });

        this.busy = false;
        this.noMatch = this.checkInData.length == 0;

        this.dataSource = new MatTableDataSource(this.checkInData);
        this.dataSource.sort = this.sort;

      } catch (error) {
        this.spinner.hide();
        this.busy = false;
        this.checkInData = [];
        this.showError("Ett fel uppstod vid inläsning av data.");
      }
    }
  }

  showError(message: string) {
    this.toaster.error(message);
  }

  private addHoursAndMinutesFromTimePickerString(date: Date, timePicker: any): Date {

    const hoursToAdd = timePicker.split(":")[0];
    const minutesToAdd = timePicker.split(":")[1];

    date.setHours(hoursToAdd);
    date.setMinutes(minutesToAdd);

    return date;
  }

  get startTimeInput() {
    return this.searchForm.get("startTime");
  }

  get endTimeInput() {
    return this.searchForm.get("endTime");
  }

  get startDateInput() {
    return this.searchForm.get("startDate");
  }

  get endDateInput() {
    return this.searchForm.get("endDate");
  }


}
